// Backend persistence for manual paper accounts (routes/manual_paper.py), plus
// read-only access to the autonomous-engine accounts. The engine math stays
// client-side in engine.js; the server stores each account blob with a version
// so two devices can't silently overwrite each other.
import axios from "axios";
import { marketFetchJson } from "../../components/arena/marketApi";

const API = `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "")}/api`;
const BASE = `${API}/manual-paper`;

export const fetchManualState = () => marketFetchJson(`${BASE}/state`);

export async function createManualAccount(account) {
  const { data } = await axios.post(`${BASE}/accounts`, { account }, { timeout: 15000 });
  return data; // { id, version, account }
}

// Resolves { ok: true, version } or { conflict: <server copy> } on a stale write.
export async function saveManualAccount(account, ifVersion) {
  try {
    const { data } = await axios.put(`${BASE}/accounts/${encodeURIComponent(account.id)}`,
      { account, if_version: ifVersion }, { timeout: 15000 });
    return { ok: true, version: data.version };
  } catch (e) {
    if (e?.response?.status === 409 && e.response.data?.current) return { conflict: e.response.data.current };
    if (e?.response?.status === 404) return { missing: true };
    throw e;
  }
}

export const deleteManualAccount = (id) =>
  axios.delete(`${BASE}/accounts/${encodeURIComponent(id)}`, { timeout: 15000 });

export const saveManualSettings = (settings) =>
  axios.put(`${BASE}/settings`, { settings }, { timeout: 15000 });

// ── Engine accounts (view only) ──
export async function fetchEngineAccounts() {
  const [acc, pos] = await Promise.all([
    marketFetchJson(`${API}/paper/accounts`),
    marketFetchJson(`${API}/positions`),
  ]);
  return {
    accounts: Array.isArray(acc?.accounts) ? acc.accounts : [],
    positions: Array.isArray(pos?.positions) ? pos.positions : [],
  };
}
